import { Layout, Text } from 'ds';

import { ReactComponent as OneIcon } from './1.svg';
import { ReactComponent as TwoIcon } from './2.svg';
import { ReactComponent as ThreeIcon } from './3.svg';

const HowItWorks = () => {
  return (
    <Layout flex direction="column" gap={24}>
      <Text size="headline-md">How it works</Text>
      <Layout flex direction="column" gap={24}>
        <Layout flex direction="row" gap={24}>
          <Layout>
            <OneIcon width={20} height={40} />
          </Layout>
          <Layout flex direction="column" gap={12}>
            <Text size="body-md" semibold>
              Select your ideal space
            </Text>
            <Text size="body-md" color="gray-500">
              Browse and tour private offices in or out of Codi’s network. Lease the perfect space for your team’s
              location, size, and budget.
            </Text>
          </Layout>
        </Layout>
        <Layout flex direction="row" gap={24}>
          <Layout>
            <TwoIcon width={32} height={40} />
          </Layout>
          <Layout flex direction="column" gap={12}>
            <Text size="body-md" semibold>
              Automate office operations
            </Text>
            <Text size="body-md" color="gray-500">
              Choose your service packages and let your Codi virtual office assistant handle everything from setup and
              design to daily operations.
            </Text>
          </Layout>
        </Layout>
        <Layout flex direction="row" gap={24}>
          <Layout>
            <ThreeIcon width={32} height={40} />
          </Layout>
          <Layout flex direction="column" gap={12}>
            <Text size="body-md" semibold>
              Move-in and thrive
            </Text>
            <Text size="body-md" color="gray-500">
              Step into your fully-equipped office on day 1. Customize and scale services as your team grows — all
              managed seamlessly through one platform.
            </Text>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default HowItWorks;
